import { jsx as _jsx } from "react/jsx-runtime";
import { CommandEmpty } from "@air/cmdk";
export const ComboboxEmpty = (param)=>{
    let { children, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(CommandEmpty, {
        className: "p-2 text-center text-14 text-grey-11",
        "data-testid": "COMBOBOX_EMPTY",
        ...restOfProps,
        children: children
    });
};
